module.exports = "<p>\n  watch works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/micro-components/p-component/p.component.html
// module id = 16
// module chunks = 0 1